import {
    useConfirmationModalContext,
    getGenericConfirmationModalComponent,
} from "features/modals/WorkspaceConfirmationModalV2"
import { useAppSelector } from "integrations/redux/hooks"
import { useEffect } from "react"
import { useBlocker } from "react-router"
import {
    selectChecklistFormHasChanges,
    selectChecklistTitleHasChanges,
    selectChecklistDescriptionHasChanges,
} from "./slice"

export function useChecklistUnsavedChangesBlocker(disabled: boolean = false) {
    const confirmationModal = useConfirmationModalContext()
    const formHasChanges = useAppSelector(selectChecklistFormHasChanges)
    const titleHasChanges = useAppSelector(selectChecklistTitleHasChanges)
    const descriptionHasChanges = useAppSelector(selectChecklistDescriptionHasChanges)
    const hasChanges = formHasChanges || titleHasChanges || descriptionHasChanges
    const blocker = useBlocker(
        ({ currentLocation, nextLocation }) =>
            !disabled && hasChanges && currentLocation.pathname !== nextLocation.pathname
    )
    useEffect(() => {
        if (blocker.state === "blocked" && !confirmationModal.isOpen) {
            confirmationModal
                .confirm({
                    RenderComponent: getGenericConfirmationModalComponent({
                        title: "Discard Changes?",
                        message: "Your unsaved changes will be discarded, do you want to proceed?",
                        confirmText: "Discard Changes",
                    }),
                })
                .then((res) => {
                    if (res) {
                        blocker.proceed()
                    } else {
                        blocker.reset()
                    }
                })
        }
    }, [blocker, blocker.state, confirmationModal])
}
